import React from "react";

import { CREDIT, SITE_NAME } from "../../data/content";

//Wix said "© 2022 by Beechwood Gardens" - the year now stays current
const Footer = () => (
  <footer className={"site-footer"}>
    <p>
      © {new Date().getFullYear()} by {SITE_NAME}. Created by{" "}
      <a
        href={CREDIT.link}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        {CREDIT.label}
      </a>
    </p>
  </footer>
);

export default Footer;
